"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaTagFromJSON = MetaTagFromJSON;
exports.MetaTagFromJSONTyped = MetaTagFromJSONTyped;
exports.MetaTagToJSON = MetaTagToJSON;
exports.MetaTagToJSONTyped = MetaTagToJSONTyped;
const runtime_1 = require("../runtime");
function MetaTagFromJSON(json) {
    return MetaTagFromJSONTyped(json, false);
}
function MetaTagFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': !(0, runtime_1.exists)(json, 'key') ? undefined : json['key'],
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : json['value'],
    };
}
function MetaTagToJSON(value) {
    return MetaTagToJSONTyped(value, false);
}
function MetaTagToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'value': value.value,
    };
}
